module.exports = __webpack_public_path__ + "media/src/img/ban-4-b1b72ed92a1c906c9e1161ce662fcc9c.svg";